module.exports = __webpack_public_path__ + "img/Icone_Gestor.f70389ef.svg";